/**
 * Booking / budget **rate line** amounts on the legacy wire (REST + Redux): integers in the
 * smallest currency subdivision (e.g. cents). Resourcing UI and forms use normal decimal
 * `number` amounts (e.g. 12.5 for twelve dollars fifty).
 *
 * Convert only when crossing that wire (`updateBooking`, `updateResourceSlot`, etc.).
 */

export function rateAmountToBookingWire(
  amount: number | null | undefined
): number | null {
  if (amount == null || !Number.isFinite(amount)) {
    return null;
  }
  return Math.round(amount * 100);
}

export function rateAmountFromBookingWire(
  wireAmount: number | null | undefined
): number | null {
  if (wireAmount == null || !Number.isFinite(wireAmount)) {
    return null;
  }
  return wireAmount / 100;
}

/** Normalize draft / dirty-field values to a finite decimal for {@link rateAmountToBookingWire}. */
export function coerceRateAmount(
  value: string | number | null | undefined
): number | null {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : null;
}
